import Vue from 'vue'
import VueRouter from 'vue-router'
const Index=()=>import('../views/index')
const PcHome=()=>import('../views/PcHome')
const Contact=()=>import('../views/Contact')
const About=()=>import('../views/About')
const H5Home=()=>import('../views/H5Home')
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/H5home',
      name: 'h5Home',
      component: H5Home
    },
    {
      path: '/PcHome',
      name: 'pcHome',
      component: PcHome
    },
]

const router = new VueRouter({
  mode: 'hash',
 /* base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),*/
  routes
})

export default router
